<template>
  <el-dialog
    :visible.sync="visibleModel"
    title="Contract List"
    width="700px"
    top="200px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table :data="tableList" border :maxHeight="400">
      <el-table-column label="Name" prop="companyName" show-overflow-tooltip>
        <template v-slot:default="{row}">
          <span>{{ maskLogic(row.companyName) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Type" prop="parentTypeName" show-overflow-tooltip/>
      <el-table-column label="Sales" prop="salesName" show-overflow-tooltip/>
      <el-table-column label="Contract Expiry Date" prop="contractValidity" show-overflow-tooltip>
        <template v-slot:default="{row}">
          <span>{{ row.contractValidity ? dayjs(row.contractValidity).format('YYYY-MM-DD') : "" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-button @click="handleClose">Close</el-button>
    </template>
  </el-dialog>
</template>
<script>
import dayjs from "dayjs";

export default {
  name: "NumberOfRelatedContracts",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tableList: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    visibleModel: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    dayjs,
    handleClose() {
      this.visibleModel = false;
    },
    // 掩码逻辑
    maskLogic(string) {
      if (string.length === 2) {
        return string.replace(/(.)./, `$1*`);
      }
      if (string.length <= 7) {
        let maskLength = string.length - 2;
        return string.replace(/(.).*(.)/, `$1${this.getMask(maskLength)}$2`);
      }
      if (string.length > 7 && string.length <= 16) {
        let maskLength = string.length - 6;
        return string.replace(/(.{3}).*(.{3})/, `$1${this.getMask(maskLength)}$2`);
      }
      if (string.length > 16) {
        let maskLength = string.length - 12;
        return string.replace(/(.{6}).*(.{6})/, `$1${this.getMask(maskLength)}$2`);
      }
    },
    // 根据长度生成*
    getMask(length) {
      let str = "";
      for (let i = 0; i < length; i++) {
        str += "*";
      }
      return str;
    }
  }
};
</script>

<style scoped>
/deep/ .el-form-item.is-success .el-input__inner {
  border: 1px solid #dcdfe6 !important;
}

/deep/ .el-form-item .el-input__inner {
  height: 32px;
}

/deep/ .el-form-item__content {
  line-height: 32px;
}

/deep/ .el-form-item__content .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 1;
  color: #383838;
}

/deep/ .el-dialog__header {
  padding: 15px 18px 15px 20px;
  border-bottom: 1px solid #e1e4e7 !important;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #e1e4e7;
  padding: 20px;
}

/deep/ .el-dialog__body .el-form-item__label {
  padding-bottom: 0;
}

/deep/ .el-dialog__footer .el-button {
  width: 120px;
  height: 42px;
  font-size: 16px;
}

/deep/ .el-dialog__headerbtn {
  top: 16px;
}

/deep/ .el-form-item.is-required .el-form-item__label:before {
  display: none !important;
}

/deep/ .smbsales-label_required {
  position: relative;
}

/deep/ .smbsales-label_required:before {
  position: absolute;
  content: "*";
  color: #e60039;
  left: -10px;
  font-size: 14px;
  top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/smbSales/components/NumberOfRelatedContracts.vue